import { useQuery } from '@tanstack/react-query';
import { CustomFieldDefinitionWithTargets } from 'types/customField';
import request from 'utils/request';

export const EVENTS_CUSTOM_FIELDS_KEY = 'events-custom-fields';

function getEventCustomFields({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) {
  return request(
    `/schoolyears/${schoolyearId}/schools/${schoolId}/events-custom-fields`,
    {
      method: 'GET',
    },
  ).then<CustomFieldDefinitionWithTargets[]>(res => res.data);
}

export const useEventCustomFieldDefinitions = ({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) =>
  useQuery({
    queryKey: [EVENTS_CUSTOM_FIELDS_KEY, schoolyearId, schoolId],
    queryFn: () => getEventCustomFields({ schoolyearId, schoolId }),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
